export const OLD_WEB_APP_CATEGORY = '[OLD] Front office'
export const CHAT_WIDGET_CATEGORY = 'Chat widget'

export const PAGE_VIEW = 'pageView'
